<template>
  <div class="menu">
    <div class="page__wr">
      <div class="menu__content-wr">
        <div class="menu__content">
          <h1 class="menu__title">{{ h1 }} /
            <a class="menu__bar-title"
               href="https://neboavax.ru/img/bar_220x130.pdf"
               target="_blank"><span>Бар</span>
              <svg xmlns="http://www.w3.org/2000/svg"
                   width="16"
                   height="16"
                   fill="currentColor"
                   class="bi bi-box-arrow-up-right"
                   viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                <path fill-rule="evenodd"
                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
              </svg>
            </a>
          </h1>
          <div class="menu__wr">
            <div class="menu__preloader"
                 :class="{'menu__preloader--show': preloader}">
              <div class="book">
                <div class="inner">
                  <div class="left"></div>
                  <div class="middle"></div>
                  <div class="right">
                  </div>
                </div>
                <ul>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div class="menu__categories-slider js-menu__categories-slider"
                 v-if="menu">
              <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"ы
                       v-for="(slide, index) in menu"
                       :key="slide.id"><a
                      class="menu__categories-slider-item"
                      :href="`#${slide.id}`"
                      :data-id="slide.id"
                      :data-index="index"
                      :class="{'menu__categories-slider-item--active': index == 0}"
                      @click="setCategory($event)">{{ slide.title }}</a></div>
                </div>
              </div>
              <div class="swiper-button-prev">
                <SvgIcon class="menu__slider-ico"
                         name="arrow-left2"
                         width="7"
                         height="11"></SvgIcon>
              </div>
              <div class="swiper-button-next">
                <SvgIcon class="menu__slider-ico"
                         name="arrow-left2"
                         width="7"
                         height="11"></SvgIcon>
              </div>
            </div>
            <div class="menu__category"
                 v-for="category in menu"
                 :key="category.id"
                 :data-id="category.id">
              <div class="menu__category-title"
                   v-if="category.title"
                   v-html="category.title"></div>
              <div class="menu__category-items"
                   v-if="category.items">
                <div class="menu__category-item"
                     v-for="item in category.items">
                  <img class="menu__category-item-img"
                       v-if="item.img"
                       :src="item.img.prev"
                       :data-src="item.img.full"
                       data-fancybox="item-img" />
                  <div v-else class="menu__category-item-img">
                    <img class="menu__category-item-img-empty"
                         src="/img/logo.svg"
                         :data-src="item.img.full"
                         data-fancybox="item-img" />
                  </div>

                  <div class="menu__category-item-title"
                       v-if="item.title"
                       v-html="item.title"></div>
                  <div class="menu__category-item-row">
                    <div class="menu__category-item-size"
                         v-if="item.size">{{ item.size }}
                    </div>
                    <div class="menu__category-item-price"
                         v-if="item.price">
                      {{ item.price.value + ' ' + item.price.currency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="menu__bottom-nav">
            <div class="page__wr">
              <BottomNav :links="links"/>
            </div>
            <Samedia/>
          </div>
        </div>
      </div>
    </div>
    <ScrollTop/>
  </div>
</template>

<script>
import EventBus from '@/eventBus';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import ScrollTop from '@/components/common/scrollTop/scrollTop.vue';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'Menu',

  mixins: [AjaxHelpersVue, determineWindowSize],

  components: {
    BottomNav,
    Samedia,
    SvgIcon,
    ScrollTop,
  },

  data() {
    return {
      countOfSlideInPage: 0,
      gallery: null,
      menu: null,
      preloader: false,
      links: {
        prev: {
          href: "/sobytiya",
          txt: "События"
        },
        next: {
          href: "/gosti",
          txt: "Гости"
        }
      }
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadMenuPage', url => {
      this.request(url);
    });
  },

  methods: {
    request(url) {
      this.req('MenuPage:getMenuPage', {url}, res => {
        if (this.checkProperty(res.content.gallery)) {
          this.gallery = res.content.gallery;
        }

        this.determineWindowSize();
        EventBus.$emit('pageDone');

        this.loadMenu();

        this.$nextTick(() => {
          this.initFancy();
        });
      }, 'menu');
    },

    loadMenu() {
      this.menu = null;
      this.preloader = true;

      this.req('MenuPage:loadMenu', {}, res => {
        if (this.checkProperty(res.content.menu)) {
          this.menu = res.content.menu;
          this.preloader = false;

          this.$nextTick(() => {
            this.initCategoriesSlider();
            this.initFancy();
          });
        }
      }, 'menu');
    },

    initFancy() {
      let $fancyEls = $('.menu__content').find('[data-fancybox]');
      let btnTmpl = '<svg viewBox="0 0 21 38" id="arrow-left" width="12px" height="26px"><path d="M17.027 37.56L21 33.243 7.946 19.06 21 4.877 17.027.56 0 19.06z"></path></svg>';

      $fancyEls.fancybox({
        loop: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        hash: false,
        btnTpl: {
          smallBtn:
              '<button data-fancybox-close class="fancybox-close-small">' +
              '<svg viewBox="0 0 31 31" id="close" width="32px" height="32px"><g fill-rule="evenodd"><path d="M2.772.41L30.35 27.989l-2.121 2.121L.65 2.532z"></path><path d="M.65 27.988L28.229.41l2.121 2.121L2.772 30.11z"></path></g></svg>' +
              '</button>',

          arrowLeft:
              '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
              + btnTmpl +
              '</button>',

          arrowRight:
              '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
              + btnTmpl +
              '</button>'
        }
      })
    },

    initCategoriesSlider() {
      let $slider = $('.js-menu__categories-slider');
      let $sliderNextBtn = $slider.find('.swiper-button-next');
      let $sliderPrevBtn = $slider.find('.swiper-button-prev');

      if ($slider.find('.swiper-slide-active').length) return;

      let sliderParams = {
        init: false,
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
          nextEl: $sliderNextBtn,
          prevEl: $sliderPrevBtn
        },
        simulateTouch: true,
        observer: true, // если слайдер изначально скрыт
        observeParents: true // если слайдер изначально скрыт
      };

      if ($slider.length) {
        let swiper = new Swiper(this.$refs.swiperContainer, sliderParams);
        swiper.init();
      }

      $(window).on('scroll', () => {
        $('.menu__category').each((i, el) => {
          let id = $(el).data('id');
          let swiper = $('.menu__categories-slider').find('.swiper-container')[0].swiper;
          let $item = $('.menu__categories-slider-item[data-id="' + id + '"]');

          if (this.isInTopOfViewport($(el), 64)) {
            $item.addClass('menu__categories-slider-item--active');

            swiper.slideTo($item.data('index'));

            setTimeout(() => {
              history.pushState(null, null, location.pathname + '#' + id);
            }, 250);
          } else {
            $item.removeClass('menu__categories-slider-item--active');
          }
        });
      });

      setTimeout(() => {
        if (location.hash) {
          let id = location.hash.substring(1);
          let block = $('.menu__category[data-id="' + id + '"]');

          $('html, body').stop().animate({
            scrollTop: block.offset().top - 56
          }, 1500);
        }
      }, 250);
    },

    setCategory(e) {
      let id = $(e.target).data('id');
      let block = $('.menu__category[data-id="' + id + '"]');

      $('html, body').stop().animate({
        scrollTop: block.offset().top - 56
      }, 1500);

      e.preventDefault();
    },

    isInTopOfViewport($el, offset) {
      if (!$el.length) return false;

      offset = offset || 0;

      let elementTop = $el.offset().top;
      let elementBottom = elementTop + $el.outerHeight(true);
      let viewportTop = $(window).scrollTop() + offset;

      return viewportTop > elementTop && viewportTop < elementBottom;
    },
  }
}
</script>
